<!-- 弹出层组件 -->
<template>
  <div v-if="open" class="popUp">
    <div class="popup-bottom-wrapper">
      <div class="popup-bottom-content">
        <div class="popup-bottom-logo">
          <img src="@/assets/images/pop-success.png" alt="" v-if="popupStatus == 'success'">
          <img src="@/assets/images/pop-fail.png" v-else alt="">
        </div>
        <div class="popup-bottom-content-title">{{ popupTitle }}</div>
        <div class="popup-bottom-content-text">{{ popupText }}</div>
        <div class="popup-bottom-content-text" style="margin-top: 4px;" v-if="billingAddress">
          {{ $t('message.checkout.billingAddressTip', {
            billingAddress: billingAddress
          }) }}
        </div>
        <div class="popup-bottom-content-btn" v-if="showReturnBtn" @click="routeTo">
          {{ $t('message.checkout.returnMerchant') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'popupBottom',
  props: {
    showReturnBtn: {
      type: Boolean,
      default: true,
    },
    open: {
      type: Boolean,
      default: true,
    },
    popupStatus: {
      type: String,
      default: '',
    },
    popupTitle: {
      type: String,
      default: '',
    },
    popupText: {
      type: String,
      default: '',
    },
    billingAddress: {
      type: String,
      default: '',
    },
    redirectUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  methods: {
    routeTo() {
      if (this.redirectUrl) {
        window.location.href = this.redirectUrl;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.popUp {
  width: 100%;
  z-index: 10000;
  background: rgba(102, 112, 133, 0.7);
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  backdrop-filter: blur(10px);

}

.popup-bottom-wrapper {
  width: 100%;
  background-color: white;
  position: fixed;
  bottom: 0;
  // min-height: 278px;
  background: #FFFFFF;
  box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.05);
  border-radius: 20px 20px 0px 0px;
  padding: 24px;
  box-sizing: border-box;
  text-align: left;

  .popup-bottom-logo {
    width: 40px;
    height: 40px;

    img {
      width: 100%;
    }
  }

  .popup-bottom-content-title {
    font-weight: 600;
    font-size: 20px;
    color: #1A202C;
    margin-top: 16px;
    line-height: 30px;
  }

  .popup-bottom-content-text {
    font-weight: 400;
    font-size: 14px;
    color: #667085;
    line-height: 18px;
    margin-top: 16px;

  }

  .popup-bottom-content-btn {
    width: 100%;
    height: 44px;
    line-height: 44px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px 8px 8px 8px;
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 16px;
    background: #182058;
  }

}
</style>
